import { useSession } from '@/providers/session-provider';
import { getMenuItems, getSubMenuItems } from '../utils';
import type { Route } from '../types';
import { useMemo } from 'react';
import {
  settingsMenuData,
  errandInspectionsRouteData,
  articlesRouteData,
  errandsComponentRouteData,
} from '@/app/settings/data';
import { menuData as dashboardMenuData } from '@/components/sidebar/data';
import { getPerms } from '@/lib/perms';

export function useGetRoutes(searchAble?: boolean) {
  const {
    data: {
      user: {
        isSystemManager,
        customerInformation: { is_pigello_main_account },
      },
    },
  } = useSession();
  return useMemo(() => {
    const dashboardRoutes = getMenuItems(dashboardMenuData);
    const settingsRoutes = getMenuItems(settingsMenuData);
    const errandsRoutes = getSubMenuItems(errandInspectionsRouteData);
    const articlesRoutes = getSubMenuItems(articlesRouteData);
    const errandsComponentRoutes = getSubMenuItems(errandsComponentRouteData);
    const routes: Route[] = [
      ...dashboardRoutes,
      ...settingsRoutes,
      ...errandsRoutes,
      ...articlesRoutes,
      ...errandsComponentRoutes,
    ];
    const routesWithPerms = routes.map((r) => {
      if (r.modelNames) {
        const perms = r.modelNames.map((modelName) => getPerms(modelName));
        return { ...r, canView: perms.every((p) => p.canView) };
      }
      const perms = getPerms(r.modelName);
      return { ...r, canView: perms.canView };
    });
    const filteredRoutes = routesWithPerms
      .filter((route) => {
        // Check permissions and role flags for all routes (both searchable and non-searchable)
        if (!route.canView) {
          return false;
        }
        if (route.systemManagerOnly && isSystemManager !== true) {
          return false;
        }
        if (route.pigelloAdminOnly && is_pigello_main_account !== true) {
          return false;
        }
        // For searchable routes, additionally require a detail modal model name
        if (searchAble) {
          return route.detailModalModelName !== undefined;
        }
        return true;
      })
      .sort((a, b) => a.title.localeCompare(b.title, 'sv'));
    return filteredRoutes;
  }, [isSystemManager, searchAble, is_pigello_main_account]);
}
